import { BrandModel } from './BrandModel'

export class BrandFormModel {
    id?: string|number = undefined
    idSource?: string = ''
    name: string = ""
    title: string = ""
    description: string = ""
    keywords: string = ""
    isActive: boolean = true
    allowExport: boolean = true

    constructor(b?: Partial<BrandModel>) {
        this.id = b?.id
        this.idSource = b?.idSource || undefined
        this.name = b?.name || ""
        this.title = b?.title || ""
        this.description = b?.description || ""
        this.keywords = b?.keywords || ""
        this.isActive = b?.isActive ?? true
        this.allowExport = b?.allowExport ?? true
    }

    hasIdSource():boolean {
        return !!this.idSource
    }

    hasId():boolean {
        return !!this.id
    }

    isValid():boolean {
        return !!this.name
    }
}
